// extracted by mini-css-extract-plugin
export default {"main":"main--300234d9","toolbar":"toolbar--c6e9d40f","content":"content--248c2438","navigation":"navigation--55b5110c","prev":"prev--68df3e1b","next":"next--d30fbc10"};